/**
 * @module router/cuenta-medica
 * @description Rutas del módulo Cuenta Médica: transacciones y liquidaciones
 */
export default [
  {
    path: "/cuenta-medica",
    component: () =>
      import(
        /* webpackChunkName: "cuenta-medica" */ "@/components/claims/CuentaMedicaLayout.vue"
      ),
    children: [
      {
        path: "",
        redirect: { name: "service-record-list" },
      },
      {
        path: "transacciones",
        name: "service-record-list",
        component: () =>
          import(
            /* webpackChunkName: "cuenta-medica" */ "@/components/claims/ServiceRecordList.vue"
          ),
      },
      // UC-REG-199 — Detalle de una TRX (pantalla separada, no drawer)
      {
        path: "transacciones/:id",
        name: "service-record-detail",
        component: () =>
          import(
            /* webpackChunkName: "cuenta-medica" */ "@/components/claims/ServiceRecordDetail.vue"
          ),
      },
      // UC-REG-217 — Resumen por prestador
      {
        path: "por-prestador",
        name: "provider-summary",
        component: () =>
          import(
            /* webpackChunkName: "cuenta-medica" */ "@/components/claims/ProviderSummary.vue"
          ),
      },
      {
        path: "liquidaciones",
        name: "liquidation-list",
        component: () =>
          import(
            /* webpackChunkName: "cuenta-medica" */ "@/components/claims/LiquidationList.vue"
          ),
      },
      // UC-REG-169 — flujo B de liquidación (submissions del prestador).
      // Aisladas del flujo viejo de `liquidaciones`.
      {
        path: "submissions",
        name: "liquidation-submission-list",
        component: () =>
          import(
            /* webpackChunkName: "cuenta-medica" */ "@/components/claims/LiquidationSubmissionList.vue"
          ),
      },
      {
        path: "submissions/new",
        name: "liquidation-submission-new",
        component: () =>
          import(
            /* webpackChunkName: "cuenta-medica" */ "@/components/claims/LiquidationSubmissionNew.vue"
          ),
      },
      {
        path: "submissions/:id",
        name: "liquidation-submission-detail",
        component: () =>
          import(
            /* webpackChunkName: "cuenta-medica" */ "@/components/claims/LiquidationSubmissionDetail.vue"
          ),
      },
    ],
  },
];
